// Updated Modal.jsx - Add portal support for full-screen overlay
import React from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-overlay') {
      onClose();
    }
  };

  // Use createPortal to render modal at document.body level
  // This ensures it's not constrained by parent containers
  return createPortal(
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>❌</button>
        {children}
      </div>
    </div>,
    document.body  // Render directly in document body, not in component tree
  );
}

export default Modal;
